exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user-list[data-v-e1bacd30] {\n  height: 100%;\n  overflow: auto;\n  padding-left: 5px;\n  padding-top: 8px;\n}\n.img-msg[data-v-e1bacd30] {\n  border-radius: 50%;\n  width: 50px;\n  margin-right: 5px;\n}\n.user-element[data-v-e1bacd30] {\n  font-size: 20px;\n  vertical-align: middle;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e1bacd30","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vue-beautiful-chat/src/UserList.vue
// module id = 1952
// module chunks = 116